export const dashboardPath = {
  /* inject path */
  DASHBOARD: '/dashboard',
  ALL: '/dashboard/all',
  TRENDS: '/dashboard/trending',
  HASHTAGS: '/dashboard/hashtags',
  SETS: '/dashboard/sets',
  INFLUENCERS: '/dashboard/influencers',
  ENTITIES: '/dashboard/entities',
  VIDEOS: '/dashboard/videos',
  NEWS: '/dashboard/news',
  USERS: '/dashboard/users',
  TOPICS: '/dashboard/topics',
  REPORTS: '/dashboard/reports',
  SETTINGS: '/settings/settings',
  ARCHIVE: '/dashboard/archive',
  TWEETS: '/dashboard/tweets',
  ADMIN: '/dashboard/admin',
  POSTS: '/dashboard/posts',
};
